import '../App.css'
import React from 'react'
import './HeroSection.css'

function ComingSoonHero() {
    return (
        <div className='hero-container'>
            <h1>Coming Soon Stay Tuned....</h1>
        </div>
    )
}

export default ComingSoonHero